export default __webpack_public_path__ + "static/media/Instagram.4c302aef.svg";